import type { FakeRouteConfig } from 'vite-plugin-fake-server/client';
import { SecurityDomainError } from '@/services/business/security/problems';
import { resultSuccess } from './utils';

export function securityProblem(error: SecurityDomainError) {
  return {
    code: error.status,
    msg: error.message,
    data: null,
    problem: {
      type: `urn:problem:security:${error.code}`,
      title: error.message,
      status: error.status,
      code: error.code,
      ...(error.details ? { details: error.details } : {}),
    },
  };
}
export function securityResult(work: () => unknown) {
  try {
    return resultSuccess(work() ?? null);
  } catch (error) {
    if (error instanceof SecurityDomainError) {
      return securityProblem(error);
    }
    throw error;
  }
}
type Route = Exclude<FakeRouteConfig, FakeRouteConfig[]>;
function normalizePermissionResult(payload: unknown) {
  if (
    payload &&
    typeof payload === 'object' &&
    'code' in payload &&
    (payload.code === 401 || payload.code === 403)
  ) {
    return securityProblem(new SecurityDomainError('permissionDenied', payload.code));
  }
  return payload;
}
function normalizeRoute(route: Route): Route {
  if (!route.url.startsWith('/platform/security') || !route.response) {
    return route;
  }
  const response = route.response;
  return {
    ...route,
    response: async (request, incomingMessage, serverResponse) =>
      normalizePermissionResult(
        await response(request, incomingMessage, serverResponse),
      ),
  };
}
/** Normalize the existing permission middleware result; never repeats its decisions. */
export function normalizeSecurityPermissionProblems(
  routes: FakeRouteConfig,
): FakeRouteConfig {
  return Array.isArray(routes) ? routes.map(normalizeRoute) : normalizeRoute(routes);
}
